
import React from 'react';
import { Handle } from 'react-flow-renderer';
const ObtRamasArbol=(id,noramas,isConnectable)=>{
    let cadena=[];
    let idrama='';
    if (id!=="n0"){
        idrama=id+"-r0";
        cadena.push(<Handle type="target" position="left" id={idrama} isConnectable={isConnectable}/>)
    }
    for (let ii=1;ii<=noramas;ii++){
      idrama=id+"-r"+String(ii);
      cadena.push(<Handle type="source" position="right" id={idrama} isConnectable={isConnectable}/>)
    }
    return cadena;
}
export default ObtRamasArbol;